import { useEffect } from "react";
import { useUserContext } from "@context/UserContext";

const useSegmentIdentify = () => {
  const { user } = useUserContext();

  useEffect(() => {
    if (!window.analytics) {
      return;
    }

    if (!user) {
      return;
    }

    window.analytics.identify(`${user.personId}`, {
      email: user.email,
      // Using snake_case to match internal Segment naming conventions
      user_type: user.userType,
    });
  }, [user]);
};

export default useSegmentIdentify;
